import { DoubleMap } from "../structures/doubleMap";
import { SchemaNames } from "./schemaConstants"

const PERIODS = ["1", "2", "3", "4"]

export const FILE_EXTENSION = {
    PDF: 'pdf',
    PNG: "png"
} as const

class ResourceCategory {
    static REPORT = "Report"
    static PRESENTATION = "Presentation"
    static PRESS_RELEASE = "Press Release"
    static INCOME_STATEMENT = SchemaNames.IS
    static BALANCE_SHEET = SchemaNames.BS
    static KPI = "KPI"
    static CASH_FLOW = SchemaNames.CF
    /** Due to a typo here we need to have both versions of the REPORT_SUPPLEMENT
     * the corrected one and the one with a typo
     */
    static REPORT_SUPLEMENT = "Report Suplement"
    static REPORT_SUPPLEMENT = "Report Supplement"
    static SEG_BY_PROD = SchemaNames.SEG_BY_PROD
    static SEG_BY_REG = SchemaNames.SEG_BY_REG
    static OUTLOOK = "Outlook"
    static PRESENTATION_OUTLOOK = "Presentation Outlook"
    static REPORT_OUTLOOK = "Report Outlook"
    static PRESS_RELEASE_OUTLOOK = "Press Release Outlook"
    static EIGHT_K = "8K"
    static EIGHT_Q = "8Q"
    static TEN_K = "10K"
    static TEN_Q = "10Q"
    static WEBSITE = "Website"
    static RECONCILIATION = "Reconciliation"
}

const RESOURCE_CATEGORIES = [
    ResourceCategory.REPORT,
    ResourceCategory.PRESENTATION,
    ResourceCategory.PRESS_RELEASE,
    ResourceCategory.INCOME_STATEMENT,
    ResourceCategory.BALANCE_SHEET,
    ResourceCategory.KPI,
    ResourceCategory.CASH_FLOW,
    ResourceCategory.OUTLOOK,
    ResourceCategory.PRESENTATION_OUTLOOK,
    ResourceCategory.REPORT_OUTLOOK,
    ResourceCategory.PRESS_RELEASE_OUTLOOK,
    ResourceCategory.REPORT_SUPPLEMENT,
    ResourceCategory.SEG_BY_PROD,
    ResourceCategory.SEG_BY_REG,
    ResourceCategory.EIGHT_K,
    ResourceCategory.EIGHT_Q,
    ResourceCategory.TEN_K,
    ResourceCategory.TEN_Q,
    ResourceCategory.RECONCILIATION
]

const RESOURCE_SOURCE_TYPES = [
    ResourceCategory.REPORT,
    ResourceCategory.PRESENTATION,
    ResourceCategory.PRESS_RELEASE,
    ResourceCategory.REPORT_SUPPLEMENT,
    ResourceCategory.EIGHT_K,
    ResourceCategory.EIGHT_Q,
    ResourceCategory.TEN_K,
    ResourceCategory.TEN_Q,
    ResourceCategory.WEBSITE,
]

const RESOURCE_SOURCE_TYPES_SHORT_FORMS = {
    [ResourceCategory.REPORT]: "R", [ResourceCategory.PRESS_RELEASE]: 'PR', [ResourceCategory.PRESENTATION]: "P",
    [ResourceCategory.EIGHT_K]: "8K", [ResourceCategory.EIGHT_Q]: "8Q", [ResourceCategory.TEN_K]: "10K",
    [ResourceCategory.TEN_Q]: "10Q", [ResourceCategory.WEBSITE]: "W", [ResourceCategory.REPORT_SUPPLEMENT]: "RS"
}

const RESOURCE_TYPE_FORMS_DOUBLE_MAP = new DoubleMap(RESOURCE_SOURCE_TYPES_SHORT_FORMS)

export { PERIODS, RESOURCE_CATEGORIES, ResourceCategory, RESOURCE_SOURCE_TYPES, RESOURCE_SOURCE_TYPES_SHORT_FORMS,
        RESOURCE_TYPE_FORMS_DOUBLE_MAP }
